import React from 'react';
import { connect } from 'react-redux';
import { Modal, Spin, List, Select, message } from 'antd';
import AttachFilesWrapper from './AttachFiles.style';
import { toggleAttachPopup, setReportsToAttach, attachReportFilesToUser } from '../../../redux/actions/Box/BoxActions';

const Option = Select.Option;

class AttachFiles extends React.Component {
  
  constructor() {
    super();
    this.closeAttachModal = this.closeAttachModal.bind(this);
    this.handleReportsToAttach = this.handleReportsToAttach.bind(this);
    this.addReportsToAttach = this.addReportsToAttach.bind(this);
  }

  closeAttachModal() {
    this.props.toggleAttachPopup(false);
  }

  handleReportsToAttach(values) {
    this.props.setReportsToAttach(values);
  }

  addReportsToAttach() {
    if(this.props.BOXREDUCER.reports_to_attach.length) {
      let user_id = this.props.BOXREDUCER.conversation_user.id;
      let report_id = this.props.BOXREDUCER.conversation_report.report_id;
      let report_list = this.props.BOXREDUCER.reports_to_attach;
      this.props.attachReportFilesToUser(user_id,report_id,report_list);
    }
    else {
      message.error('Select from list of reports to attach!');
    }
  }
  
  render() {
    
    let user_reports = this.props.BOXREDUCER.attach_report_list.hasOwnProperty('user_reports') ? this.props.BOXREDUCER.attach_report_list.user_reports.sheets : [] ;
    let available_reports_list = this.props.BOXREDUCER.attach_report_list.hasOwnProperty('report_list') && this.props.BOXREDUCER.attach_report_list.report_list.length ? this.props.BOXREDUCER.attach_report_list.report_list.map((report,i) => <Option key={i} value={report.type+`:`+report.id}>{ report.name.split("/")[2] + ` ( ` + report.type + ` )`}</Option>) : [] ;
    
    return(
      <AttachFilesWrapper>
        <Modal
          visible={this.props.BOXREDUCER.attach_popup_visible}
          title={<h3 className="conversation-header">{this.props.BOXREDUCER.conversation_report.hasOwnProperty('title') ? this.props.BOXREDUCER.conversation_report.title : ''}</h3>}
          onOk={this.addReportsToAttach}
          okText="Update"
          okButtonProps={{ loading: this.props.BOXREDUCER.is_report_attaching }}
          onCancel={this.closeAttachModal}
          className="attach-files-modal"
        >
          <Spin spinning={this.props.BOXREDUCER.attach_popup_loading} tip="Loading List of Files">
            <div className="attach-files-container">
              <div className="purchased-user-reports">
                <List
                  header={<div className="flex report-list-header">
                            <p className="report-name">Name</p>
                            <p className="report-type">Type</p>
                          </div>}
                  dataSource={user_reports}
                  renderItem={(report,i) => (<List.Item key={i+1}>
                    <div className="flex report-list-item">
                      <p className="report-name">{report.name}</p>
                      <p className="report-type">{report.type}</p>
                    </div>
                    </List.Item>)}
                  pagination={true}
                />
              </div>
              <div className="update-user-reports">
                <h3>Show available reports list here</h3>
                <Select style={{ width: '100%' }} onChange={this.handleReportsToAttach} allowClear mode="multiple" placeholder="Select reports to attach" value={this.props.BOXREDUCER.reports_to_attach}>
                    {available_reports_list}
                </Select>
              </div>
            </div>
          </Spin>
        </Modal>
      </AttachFilesWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  toggleAttachPopup,
  setReportsToAttach,
  attachReportFilesToUser
};

export default connect(mapStateToProps,mapDispatchToProps)(AttachFiles);


// WEBPACK FOOTER //
// ./src/components/Box/AttachFiles/AttachFiles.js